export enum AdPolicyId {
	SystemUpdate = 'E40B12CE-C5DD-4571-BBC6-7EA5879A8472',
	AutoUpdateCriticalUpdates = 'AutoUpdateCriticalUpdates',
	AutoUpdateRecommendedUpdates = 'AutoUpdateRecommendedUpdates',
	AcceptEULAAutomatically = 'AcceptEULAAutomatically',
	AutoUpdateEnabled = 'AutoUpdateEnabled',
	SystemUpdateFilter = 'SystemUpdateFilter'
}

export enum AdPolicyEvent {
	AdPolicyUpdatedEvent = '[AdPolicy] AdPolicyUpdated'
}
